var _circle, _circle2, _circle3, _circle4, _circle5, _rect, _circle6, _circle7, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 433,
    viewBox: "0 0 376 433",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 158.264,
    cy: 207.713,
    r: 55.0428,
    transform: "rotate(-120 158.264 207.713)",
    fill: "url(#paint0_linear_6743_56734)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.484,
    cy: 211.007,
    r: 95.9814,
    transform: "rotate(120 161.484 211.007)",
    stroke: "url(#paint1_linear_6743_56734)",
    strokeWidth: 2.11645
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5566,
    cy: 44.5566,
    r: 43.9817,
    transform: "matrix(0.5 -0.866025 -0.866025 -0.5 41.625 332.293)",
    stroke: "url(#paint2_linear_6743_56734)",
    strokeWidth: 1.14985
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.484,
    cy: 211.012,
    r: 150.157,
    transform: "rotate(120 161.484 211.012)",
    stroke: "url(#paint3_linear_6743_56734)",
    strokeWidth: 1.76614
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5014,
    cy: 271.49,
    r: 7.00129,
    transform: "rotate(-60 23.5014 271.49)",
    fill: "url(#paint4_linear_6743_56734)",
    fillOpacity: 0.854181
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 69.001,
    width: 10,
    height: 10,
    fill: "url(#paint5_linear_6743_56734)",
    fillOpacity: 0.854181
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.17,
    cy: 248.261,
    r: 8.75161,
    transform: "rotate(-60 249.17 248.261)",
    fill: "url(#paint6_linear_6743_56734)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.33,
    cy: 109.838,
    r: 5,
    transform: "rotate(-150 118.33 109.838)",
    fill: "#D0E2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.067 320.767L251.311 324.317L258.008 328.816L258.555 336.864L258.008 344.913L251.311 349.411L244.067 352.962L236.823 349.411L230.125 344.913L229.579 336.864L230.125 328.816L236.823 324.317L244.067 320.767Z",
    fill: "url(#paint7_linear_6743_56734)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6743_56734",
    x1: 158.264,
    y1: 152.67,
    x2: 158.264,
    y2: 262.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4589FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520834,
    stopColor: "#2610A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6743_56734",
    x1: 161.484,
    y1: 113.967,
    x2: 161.484,
    y2: 308.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F62FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6743_56734",
    x1: 44.5566,
    y1: 0,
    x2: 44.5566,
    y2: 89.1132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F62FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6743_56734",
    x1: 161.484,
    y1: 59.9722,
    x2: 161.484,
    y2: 362.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F62FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6743_56734",
    x1: 23.5014,
    y1: 264.489,
    x2: 23.5014,
    y2: 278.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD33",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6743_56734",
    x1: 223,
    y1: 69.001,
    x2: 223,
    y2: 79.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4589FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6743_56734",
    x1: 249.17,
    y1: 239.509,
    x2: 249.17,
    y2: 257.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9747FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9747FF",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6743_56734",
    x1: 244.067,
    y1: 320.767,
    x2: 244.067,
    y2: 352.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ED796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ED796",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.084219b3a212bef215a7eb75452b46ca.svg";
export { ForwardRef as ReactComponent };